<template>
  <div v-if="hubbdata">
    <v-app-bar app class="toolbar white--text" light tag="div" fixed>
      <div class="toolbar__content">
        <div class="toolbar__inner">
          <v-app-bar-nav-icon
            @click="toggleDrawer"
            class="hidden-md-and-up white--text"
            aria-label="Menu"
            data-cypress-value="menu"
            id="menublock"
          ></v-app-bar-nav-icon>

          <!-- <v-btn
                    icon
                    large
                    aria-label="Go to home page"
                    @click="goHome"
                    class="black--text"
                    v-if="$route.name !== 'home'"
                >
                    <v-icon>mdi-home</v-icon>
                </v-btn> -->

          <v-btn
            @click="$router.go(-1)"
            class="back-button white--text"
            aria-label="Menu"
            outlined
            v-if="
              $route.name === 'category' ||
                $route.name === 'organisation' ||
                $route.name === 'event' ||
                $route.name === 'cms_page' ||
                $route.name === 'search' ||
                $route.name === 'Opportunity' ||
                $route.name === 'legal' ||
                $route.name === 'about' ||
                $route.name === 'app_privacy' ||
                $route.name === 'app_terms' ||
                $route.name === 'app_accessibility' ||
                $route.name === 'education' ||
                $route.name === 'education_article'
            "
          >
            <v-icon left>
              mdi-chevron-left
            </v-icon>
            {{ hubbdata.tutorial.buttons.back }}
          </v-btn>

          <div class="d-flex w-100 justify-center page-title-wrapper">
            <h1 class="font-weight-bold page-title">
              <v-toolbar-title v-if="$route.name === 'events'">{{
                hubbdata.home.labels.events
              }}</v-toolbar-title>

              <v-toolbar-title v-else-if="$route.name === 'organisations'">{{
                hubbdata.home.labels.providers
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'opportunities'">{{
                hubbdata.home.labels.apprenticeships
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'surveys'">
                Surveys
              </v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'contact'">{{
                hubbdata.home.labels.contact
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'infoandadvice'">{{
                hubbdata.home.labels.info
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'app_terms'">{{
                hubbdata.consentpage.title
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'about'">{{
                hubbdata.home.labels.about
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'legal'">{{
                hubbdata.home.labels.legal
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'app_accessibility'">{{
                hubbdata.settings.titles.accessibility
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'app_privacy'">{{
                hubbdata.settings.titles.privacy
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'favourites'">{{
                hubbdata.favourites.title
              }}</v-toolbar-title>
              <v-toolbar-title v-else-if="$route.name === 'vips'">{{
                hubbdata.viplist.title
              }}</v-toolbar-title>

              <v-toolbar-title
                v-else-if="$route.name === 'cms_page'"
              ></v-toolbar-title>
            </h1>
          </div>

          <v-spacer></v-spacer>

          <v-btn
            icon
            large
            aria-label="Open Favourites page"
            @click="openFavourites"
            color="blue"
            v-if="favouritesCount > 0"
          >
            <span class="class sr-only">Open Favourites page</span>
            <v-badge
              :content="favouritesCount"
              color="red"
              overlap
              class="white--text"
              dark
            >
              <v-icon>
                mdi-heart
              </v-icon>
            </v-badge>
          </v-btn>

          <v-btn
            icon
            large
            aria-label="Open Search page"
            @click="openSearch"
            class="ml-2 white--text"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      app
      v-model="drawer"
      :fixed="$vuetify.breakpoint.smAndDown"
      :temporary="$vuetify.breakpoint.smAndDown"
      :permanent="$vuetify.breakpoint.mdAndUp"
      class="navigation"
    >
      <button
        :aria-label="hubbdata.header.close_menu"
        class="navigation__close"
        @click="drawer = false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          class="navigation__close-icon"
        >
          <path
            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            fill="white"
          />
        </svg>
      </button>

      <div class="navigation-drawer-image">
        <v-img
          alt=""
          contain
          class="home__logo"
          src="@/assets/redcar/logo.png"
        />
      </div>

      <v-list class="navigation__list" nav dense>
        <v-list-item-group
          active-class="primary--text text--accent-4 "
          aria-label="Navigation Items"
          class="px-2"
          role="navigation"
        >
          <v-list-item id="first-item" :to="{ name: 'home' }">
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.tabs.home }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'infoandadvice' }">
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.home.labels.info }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'education' }">
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.home.labels.education }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'organisations' }">
            <i class="mdi mdi-checkbox-blank"></i>

            <v-list-item-title>
              {{ hubbdata.home.labels.providers }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'events' }"
            data-cypress-value="events-page"
          >
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.home.labels.events }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'opportunities' }"
            data-cypress-value="opportunities-page"
          >
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.home.labels.apprenticeships }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'vips' }" data-cypress-value="vips-page">
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.viplist.title }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'favourites' }"
            data-cypress-value="favourites-page"
          >
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.favourites.title }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            :to="{ name: 'contact' }"
            data-cypress-value="contact-page"
          >
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.home.labels.contact }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'legal' }" data-cypress-value="legal-page">
            <i class="mdi mdi-checkbox-blank"></i>
            <v-list-item-title>
              {{ hubbdata.home.labels.legal }}
            </v-list-item-title>
          </v-list-item>
          <Settings />
        </v-list-item-group>

        <v-list-item
          style="flex-direction: column; width: 100%; margin-top: 30px; flex-flow: wrap; padding:0 10px;"
          class="settings__language-selector"
        >
          <v-list-item-title>
            <label
              style="font-weight:500; text-transform: none; color: $primary;"
              id="languageSelect"
              >{{ hubbdata.settings.text.languages }}</label
            >
          </v-list-item-title>

          <v-select
            v-model="selectedLang"
            :items="langs"
            style="padding-top: 10px;"
            menu-props="auto"
            name="langs"
            prepend-icon-color="primary"
            item-text="name"
            item-value="code"
            @change="updateLang(selectedLang)"
            solo
            hide-details
            :aria-label="hubbdata.settings.text.languages"
            class="settings__language-select"
          >
          </v-select>
        </v-list-item>

        <v-list-item>
          <v-btn
            class="tour-restart"
            @click="restartTheTour"
            v-html="hubbdata.tutorial.startTutorial"
          >
          </v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import favourites from "@/favourites";
import Settings from "@/components/Header/Settings.vue";
export default {
  components: {
    Settings,
  },
  name: "Header",
  data: () => ({
    drawer: false,
    selectedLang: localStorage.getItem("current_lang"),
    loading: false,
    alert: false,
    dialog: false,
    fontAlert: false,
    openDyslexic: false,
    langs: [
      { name: "English", code: "en" },
      { name: "Albanian | Shqiptare", code: "sq" },
      { name: "Amharic | አማርኛ", code: "am" },
      { name: "Arabic | عربي", code: "ar" },
      { name: "Pashto | میل", code: "ps" },
      { name: "Persian | فارسی", code: "fa" },
      { name: "Tigrinya  | ትግርኛ", code: "ti" },
    ],
  }),

  action: {},
  mounted() {
    if (localStorage.getItem("enable_font_change") === "true") {
      this.openDyslexic = true;
    } else {
      this.openDyslexic = false;
    }

    /// listening for language change emit coming form settings.vue
    /// we're passing the 'language' and then setting is as a selected one
    this.$bus.$on("language-changed-from-settings-page", (language) => {
      this.selectedLang = language;
    });
  },

  beforeDestroy() {
    // stop listening for the emit coming from settings.vue
    this.$bus.$off("language-changed-from-settings-page");
  },

  methods: {
    restartTheTour() {
      this.drawer = !this.drawer;
      localStorage.removeItem("has_seen_the_tour");
      this.$router.push({ name: "home" });
      this.$tours["myTour"].start();
    },
    toggleDrawer() {
      this.drawer = !this.drawer;

      setTimeout(selectMenuItem, 100);
      function selectMenuItem() {
        if (document.getElementsByClassName("v-list-item--active").length) {
          document.getElementsByClassName("v-list-item--active")[0].focus();
        } else {
          document.getElementById("first-item").focus();
        }
      }
    },
    loadingSpinner() {
      this.loading = !this.loading;
    },
    openSearch() {
      this.$router.push({ name: "search" });
    },
    openFavourites() {
      this.$router.push({ name: "favourites" });
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
    updateFont(font) {
      localStorage.setItem("enable_font_change", font);
      hubbdata.dispatch("updateFont", font);
      this.fontAlert = true;
    },
    updateLang(selectedLang) {
      this.loadingSpinner();
      hubbdata.dispatch("updateLang", selectedLang).then(() => {
        hubbdata.dispatch("initDB").then(() => {});
      });
      this.alert = true;
      // send a global emit back to Settings.vue with the newly selected language
      this.$bus.emit("language-changed-from-header", this.selectedLang);
    },
    DismissAlert() {
      this.alert = false;
    },
    DismissFontAlert() {
      this.fontAlert = false;
    },
  },
  computed: {
    favouritesCount() {
      return favourites.getters.favouritesCount();
    },
    currentLang() {
      let dictionary = {
        en: "English",
        ar: "Arabic",
        zh: "Chinese",
        fr: "French",
        pl: "Polish",
        so: "Somali",
        es: "Spanish",
        vi: "Vietnamese",
      };

      return dictionary[this.selectedLang];
    },
    current_cms_page() {
      return hubbdata.state.current_cms_page;
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
    messageCount() {
      let result = 0;
      for (let i = 0; i < this.conversations.length; i++) {
        result += this.conversations[i].unread_message_count;
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
.tour-restart {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 30px;
  text-transform: lowercase;

  &:focus {
    outline-color: $black;
  }
}

.toolbar .v-badge__badge {
  color: $black !important;
}

.navigation {
  width: calc(256px + var(--sal)) !important;

  &__close {
    position: absolute;
    top: calc(var(--sat) + 8px);
    right: 8px;
    background-color: $black;
    border-radius: 5px;
    width: 24px;
    height: 24px;

    &:focus {
      outline: 2px solid $black !important;
      outline-offset: 2px;
    }

    @media (min-width: 960px) {
      display: none;
    }
  }

  &__list {
    padding-bottom: var(--sab);
    padding-left: calc(var(--sal) + 8px);
  }
}

.navigation-drawer-image {
  background: white;
  border-bottom: 5px solid black;
  margin-bottom: 20px;
  padding: calc(var(--sat) + 10px) 0 10px var(--sal);
  display: flex;

  .home__logo {
    max-width: 200px;
    max-height: 80px;
    margin-top: 10px;
    position: relative;
    left: -30px;
  }
}

.settings {

  &__language-select {
    &:focus-within .v-input__control {
      outline: 2px solid $black !important;
      outline-offset: 2px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.toolbar {
  height: auto !important;

  &__content {
    width: 100%;
    background-color: $primary;
    padding-top: var(--sat);
    padding-right: var(--sar);
    padding-left: var(--sal);
  }

  &__inner {
    display: flex;
    align-items: center;
    height: 48px;
    transition: 0.2s 0.32s;
  }

  ::v-deep {
    .v-toolbar__content {
      height: auto !important;
      padding: 4px 8px;
    }
  }
}

.page-title {
  text-transform: lowercase;
  max-width: 90% !important;
  text-overflow: ellipsis;
  white-space: pre-line;
  overflow: hidden;
}

.v-navigation-drawer {
  background-color: #e9e8e6 !important;
}

a:focus {
  outline: 3px solid $black;
}

.v-alert {
  margin: 10px 0px 10px 10px !important;
  margin-left: 0px !important;
  width: 100%;
}

.v-list-item__title {
  font-size: 16px !important;
  line-height: 1.2 !important;
  text-align: left;
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
}

.users-list {
  padding-left: 0;
  display: flex;
  list-style: none;
  font-size: 11px;

  &__item {
    padding: 4px;
  }
}

.back-button {
  margin-right: 10px;
  text-transform: capitalize;
}

.banner {
  margin-top: 57px;
  font-size: 12px;
  text-align: center;
}

.sign-out {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.v-list-item__title a,
.v-list-item__title,
.v-input,
label {
  color: black !important;
  font-size: 15px;
  text-transform: lowercase;
}

.v-list-item--link {
  border-bottom: 1px solid black;
  border-radius: 0 !important;
  margin-bottom: 0 !important;
  padding: 5px 8px;
}

.label {
  margin: 10px !important;
}

i {
  color: $red;
  font-size: 10px;
  padding-right: 10px;
}

.v-input {
  border-radius: 0px;
}

.page-title-wrapper {

  @media (max-width: 450px) {
    width: 60% !important;
  }

  @media (max-width: 350px) {
    width: 45% !important;
  }
}
</style>
